export default __webpack_public_path__ + "navigation-examples-route-lines-styling-thumbnail-480-dd6f4f688bed202f32c356cdb5a3bfb5.png";